/*
 * This is an auto-generated file, any manual edits will be overridden.
 *
 * To regenerate, see instructions here:
 *   https://kolibri-dev.readthedocs.io/en/develop/i18n.html
 *
 * This file was generated by kolibri-i18n code-gen
 *
 * Polyfill files are copied to ./polyfills/ directory to avoid external dependencies.
 */
module.exports = function (locale) {
  switch (locale) {
    case 'ar':
      return import('intl/locale-data/jsonp/ar.js');
    case 'bg-bg':
      return import('intl/locale-data/jsonp/bg-BG.js');
    case 'bn-bd':
      return import('intl/locale-data/jsonp/bn-BD.js');
    case 'de':
      return import('intl/locale-data/jsonp/de.js');
    case 'el':
      return import('intl/locale-data/jsonp/el.js');
    case 'en':
      return import('intl/locale-data/jsonp/en.js');
    case 'es-es':
      return import('intl/locale-data/jsonp/es-ES.js');
    case 'es-419':
      return import('intl/locale-data/jsonp/es-419.js');
    case 'fa':
      return import('intl/locale-data/jsonp/fa.js');
    case 'fr-fr':
      return import('intl/locale-data/jsonp/fr-FR.js');
    case 'ff-cm':
      return import('intl/locale-data/jsonp/ff-CM.js');
    case 'gu-in':
      return import('intl/locale-data/jsonp/gu-IN.js');
    case 'ha':
      return import('intl/locale-data/jsonp/ha.js');
    case 'hi-in':
      return import('intl/locale-data/jsonp/hi-IN.js');
    case 'ht':
      return import('./polyfills/intl/ht.js');
    case 'id':
      return import('intl/locale-data/jsonp/id.js');
    case 'it':
      return import('intl/locale-data/jsonp/it.js');
    case 'ka':
      return import('intl/locale-data/jsonp/ka.js');
    case 'km':
      return import('intl/locale-data/jsonp/km.js');
    case 'ko':
      return import('intl/locale-data/jsonp/ko.js');
    case 'mr':
      return import('intl/locale-data/jsonp/mr.js');
    case 'my':
      return import('intl/locale-data/jsonp/my.js');
    case 'ny':
      return import('./polyfills/intl/ny.js');
    case 'pa':
      return import('intl/locale-data/jsonp/pa.js');
    case 'pt-br':
      return import('intl/locale-data/jsonp/pt-BR.js');
    case 'pt-mz':
      return import('intl/locale-data/jsonp/pt-MZ.js');
    case 'sw-tz':
      return import('intl/locale-data/jsonp/sw-TZ.js');
    case 'te':
      return import('intl/locale-data/jsonp/te.js');
    case 'uk':
      return import('intl/locale-data/jsonp/uk.js');
    case 'ur-pk':
      return import('intl/locale-data/jsonp/ur-PK.js');
    case 'vi':
      return import('intl/locale-data/jsonp/vi.js');
    case 'yo':
      return import('intl/locale-data/jsonp/yo.js');
    case 'zh-hans':
      return import('intl/locale-data/jsonp/zh-Hans.js');
    default:
      return import('intl/locale-data/jsonp/en.js');
  }
};
